// eslint-disable-next-line no-undef
const appConfig = APP_CONFIG;

export default appConfig;
